import script from "./MsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsModal.vue?vue&type=script&setup=true&lang=ts"

import "./MsModal.vue?vue&type=style&index=0&id=5f6a9496&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6a9496"]])

export default __exports__